import React, { useState, useEffect } from 'react';
import '../../css/Roombooking.css';
import people from "../../images/New folder (4)/people.png";

function Familypackage_roombooking({
  setAdults,
  adults,
  children,
  childrenAges,
  setChildren,
  setChildrenAges,
  setRooms
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [rooms, setLocalRooms] = useState(1);

  const MAX_OCCUPANTS_PER_ROOM = 3;

  // ✅ All children count as occupants (regardless of age)
  const calculateRooms = (adults, children) => {
    const totalOccupants = adults + children;
    return Math.ceil(totalOccupants / MAX_OCCUPANTS_PER_ROOM);
  };

  // Sync childrenAges array with children count
  useEffect(() => {
    let updatedAges = [...childrenAges];
    if (children > childrenAges.length) {
      for (let i = childrenAges.length; i < children; i++) {
        updatedAges.push('');
      }
    } else {
      updatedAges = updatedAges.slice(0, children);
    }
    setChildrenAges(updatedAges);
  }, [children, setChildrenAges]);

  // Recalculate rooms when adults or children change
  useEffect(() => {
    const requiredRooms = calculateRooms(adults, children);
    setLocalRooms(requiredRooms);
    setRooms(requiredRooms);
  }, [adults, children, setRooms]);

  const handleAdultChange = (change) => {
    const newAdults = Math.max(0, adults + change);
    setAdults(newAdults);
  };

  const handleChildChange = (change) => {
    const newChildren = Math.max(0, children + change);
    setChildren(newChildren);
  };

  const handleChildAgeChange = (index, value) => {
    const updatedAges = [...childrenAges];
    updatedAges[index] = value;
    setChildrenAges(updatedAges);
  };

  const resetForm = () => {
    setAdults(0);
    setChildren(0);
    setChildrenAges([]);
    setRooms(1);
    setLocalRooms(1);
    setShowDetails(false);
  }; 

  return (
    <div>
      <div className="roombooking-main-div" onClick={() => setShowDetails(!showDetails)}>
        <h1 className='roombooking-h1'>Room Booking & Vehicle</h1>
        <img src={people} alt="people" className="roomboooking-icon" />
        <p className="roombooking-p1">Guests and Rooms</p>
      </div>

      {showDetails && (
        <div className="roombooking-details">
          <div className="roombooking-row">
            <span>Adults</span>
            <button onClick={() => handleAdultChange(-1)}>-</button>
            <span>{adults}</span>
            <button onClick={() => handleAdultChange(1)}>+</button>
          </div>

          <div className="roombooking-row">
            <span>Children</span>
            <button onClick={() => handleChildChange(-1)}>-</button>
            <span>{children}</span>
            <button onClick={() => handleChildChange(1)}>+</button>
          </div>

          {children > 0 &&
            childrenAges.map((age, index) => (
              <div key={index} className="roombooking-row">
                <span>Child {index + 1} Age</span>
                <input
                  type="number"
                  min="0"
                  max="18"
                  value={age}
                  onChange={(e) => handleChildAgeChange(index, e.target.value)}
                />
              </div>
            ))}

          <div className="roombooking-row">
            <span>Rooms</span>
            <span>{rooms}</span>
          </div>

          <div className="roombooking-buttons">
            <button onClick={resetForm}>Reset</button>
          </div>
        </div>
      )}
    </div>
  );
}


export default Familypackage_roombooking;
